<template>
   <div>
    <div class="log-wrap">
      <span class="logoimg"></span>
    </div>
    <div
      class="nav"
      @open="handleOpen"
      @close="handleClose"
      text-color = "#fff"
      ref="menu"
      :default-active="activeIndex"
    >
      <div
        :index="indexRoutes[0]"
        class="menuItem"
        v-if="!!!credit"
        v-show="!role"
        v-bind:class="{'is-active': $route.name=== 'index'}"
      >
        <i class="icon-shouye icon"></i>
        <router-link class="link" to="/">首页</router-link>
      </div>
      <div
        :index="indexRoutes[1]"
        class="menuItem"
        v-if="!!!credit"
        v-show="!role"
        v-bind:class="{'is-active': $route.path===indexRoutes[1]}"
      >
        <i class="icon-gouquanguanli icon"></i>
        <router-link class="link" to="/purchasecoupon/purchase">购券管理</router-link>
        <span v-if="hasDiscount" class="discountIcon">限时{{discountInfo ? discountInfo.discount: '--'}}折</span>
      </div>
      <div
        :index="indexRoutes[2]"
        class="menuItem"
        v-bind:class="{'is-active': $route.path===indexRoutes[2]}"
      >
        <i class="icon-faquanguanli icon"></i>
        <router-link class="link" to="/sendcoupon/sendbyphone">发券管理</router-link>
      </div>
      <div v-if="!!!credit" class="menuItem noitem" v-show="!role"><i class="icon-caiwu icon"></i>财务</div>
      <div
        :index="indexRoutes[3]"
        v-if="!!!credit"
        v-show="!role"
        class="menuItem nolineitem"
        v-bind:class="{'is-active': $route.path===indexRoutes[3]}"
      >
        <router-link class="link" to="/recharge/recharge">出行券充值</router-link>
      </div>
      <div
        :index="indexRoutes[5]"
        v-if="!!!credit"
        v-show="!role"
        class="menuItem nolineitem"
        v-bind:class="{'is-active': $route.path===indexRoutes[5]}"
      >
        <router-link class="link" to="/invoice/apply">发票管理</router-link>
      </div>
      <div class="menuItem noitem" v-show="!role"><i class="icon-gongjuxiang icon"></i>工具箱</div>
      <div
       :index="indexRoutes[4]"
        class="menuItem nolineitem"
        v-show="!role"
        v-bind:class="{'is-active': $route.path===indexRoutes[4]}"
      >
        <router-link class="link" to="/teammanage">协作者管理</router-link>
      </div>
      <div
        index="api"
        class="menuItem nolineitem"
        style="padding-left:24px"
      >
        <a class="link" href="https://dpubstatic.udache.com/static/dpubimg/b99bf42860adcdb402110fbd1a6817a1/index.html" target="_blank">
          API和兑换码
        </a>
      </div>
    </div>
   </div>
</template>
<script>
import {mapState} from 'vuex'
import 'Styles/font.css'
export default {
  name: 'Nav',
  data () {
    let indexArr = ['/', '/purchasecoupon/purchase', 'sendcoupon/sendbyphone', '/recharge/recharge', '/teammanage', '/invoice/apply']
    if (this.$route.path.indexOf('sendcoupon') !== -1) {
      indexArr[2] = this.$route.path
    } else if (this.$route.path.indexOf('purchasecoupon') !== -1) {
      indexArr[1] = this.$route.path
    }else if(this.$route.path.indexOf('invoice') !== -1){
      indexArr[5] = this.$route.path
    }else if(this.$route.path.indexOf('recharge') !== -1){
      indexArr[3] = this.$route.path
    }
    return {
      role: this.$store.state.header.selfGroup ? this.$store.state.header.selfGroup.role : 1, // 0：管理员 1 协作者
      indexRoutes: indexArr,
      activeIndex: this.$route.path,
      credit:this.$store.state.header.selfGroup ? this.$store.state.header.selfGroup.credit : 0,
    }
  },
  methods: {
    handleOpen (key, keyPath) {
      console.log(key, keyPath)
    },
    handleClose (key, keyPath) {
      console.log(key, keyPath)
    }
  },
  computed: {
    ...mapState('header', ['selfGroup','hasDiscount','discountInfo'])
  },
  watch: {
    selfGroup: function (value) {
      this.role = value.role
      if (value.role) {
        this.$router.push({path: '/sendcoupon/sendbyphone'}).catch(err => {})
      } else {
        this.$router.push({path: '/'}).catch(err => {})
      }
    },
    '$route': {
      immediate: true,
      handler (value) {
        // 这里如果不用setTimeout，而用nextTick或直接this.menuIndex=r.path的话，如果菜单刚好在subMenu里面的，它不会自动展开
        setTimeout(() => {
          // menuIndex是menu组件default-active的绑定值
          if (value.name === 'sendbyphone' || value.name === 'sendCouponHistory' || value.name === 'sendCouponDetailList') {
            this.indexRoutes[2] = value.path
            // this.$refs.menu.activeIndex = value.path
          } else if (value.path.indexOf('purchasecoupon') !== -1) {
            this.indexRoutes[1] = value.path
            // this.$refs.menu.activeIndex = value.path
          }else if(this.$route.path.indexOf('invoice') !== -1){
            this.indexRoutes[5] = value.path
          }else if(this.$route.path.indexOf('recharge') !== -1){
            this.indexRoutes[3] = value.path
          }
          this.activeIndex = value.path
        }, 100)
      }
    }

    // $route: function (value) {
    //   console.log('8888')
    //   if (value.path.indexOf('sendcoupon') !== -1) {
    //     this.indexRoutes[2] = value.path
    //     // this.$refs.menu.activeIndex = value.path
    //   } else if (value.path.indexOf('purchasecoupon') !== -1) {
    //     this.indexRoutes[1] = value.path
    //     // this.$refs.menu.activeIndex = value.path
    //   }
    //   this.activeIndex = value.path
    // }
  }
}

</script>
<style  scoped  lang="stylus">
  .nav {
    div {
      font-size: 14px;
    }
  }
  .log-wrap{
    height: 70px;
    line-height: 70px;
  }
    a{
        text-decoration:none;
    }
    li{
        list-style: none
    }
    .logoimg{
      background: url('../images/start_logo_small.png');
      width: 150px;
      height: 40px;
      background-size: 100% auto;
      display: inline-block;
      background-repeat: no-repeat;
      position: relative;
      top: 24px;
    }
  .menuItem{
    text-align: left;
    border: none;
    background-color: #11111a;
  }
  .menuItem.is-active{
    background-color: #3468ff;
    color: #fff;
  }
  .menuItem{
    background-color: #11111a;
    color: #fff;
    height: 35px;
    line-height: 35px;
    font-size: 12px;
    margin: 6px 0 6px;
    float: left;
    width: 180px;
    position: relative;
  }
  .noitem:after, .nolineitem:after{
    border-bottom: none;
    content: '';
  }
  .noitem{
    padding-left: 56px;
    color: #58585F;
  }
  .noitem i{
    position: absolute;
    top: 4px;
  }
  .sspan{
    padding-left: 26px;
    display: inline-block;
    width:100%
  }
  .sspan a{
    margin-left:6px;
  }
  .menuItem{
    position relative
  }
  .menuItem a{
    text-decoration: none;
    color: #fff;
    display: inline-block;
    position: absolute;
    left: 0px;
    padding-left: 54px;
    width: 126px;
  }
  .menuItem .discountIcon{
    padding: 0 4px;
    height: 16px;
    opacity: 1;
    display: block;
    position: absolute;
    right: 7px;
    top: 10px;
    background: linear-gradient(108deg, #ff975c 3%, #f00 100%);
    /* font-family: PingFangSC-Medium; */
    font-size: 10px;
    font-weight: normal;
    line-height: 16px;
    letter-spacing: 0px;
    color: #fff;
    text-align: center;
    border-radius: 2px 2px 2px 0px;
  }
  .icon{
    font-size: 26px;
    margin-right: 10px;
    position: relative;
    top: 4px;
    left: 22px;
  }
</style>
